import * as React from 'react';

import { PrimaryPageMessagingModel } from 'models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface PaymentInstallmentMessageProps {
  primaryPageMessagingModel?: PrimaryPageMessagingModel;
}
export const PaymentInstallmentMessage: React.FunctionComponent<PaymentInstallmentMessageProps> = ({ primaryPageMessagingModel }) => (
  <>
    {primaryPageMessagingModel &&
      primaryPageMessagingModel.description && (
        <section className="uitk-cell all-y-gutter-three pwa-theme--success uitk-type-medium" data-stid="installment-payment-msg">
          {primaryPageMessagingModel.icon && <UitkIcon size={UitkIconSize.EXTRA_SMALL} name={primaryPageMessagingModel.icon} />}
          {primaryPageMessagingModel.description}
        </section>
      )}
  </>
);
